module.exports = __webpack_public_path__ + "8df238052b8bcc6a74f8f1b2374b8d5e.svg";